import TagManager from 'react-gtm-module';

export const gtmTrack = (data: TagManager.DataLayerArgs) => {
  TagManager.dataLayer({
    ...data,
  });
};

export const gtmInit = (gtmId: string) => {
  TagManager.initialize({ gtmId });
};
